import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import ShowMoreButton from "@components/ShowMoreButton";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import {
  TERMS_CACHE_TIME,
  TERMS_STALE_TIME,
  getTermsList,
} from "../../api/terms";
import PdfIcon from "@assets/pdf.svg?react";
import ArrowIcon from "@assets/arrow.svg?react";
import DOMPurify from "dompurify";

const dateFormatter = (dateString) => {
  const formattedDate = new Intl.DateTimeFormat("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate.format(new Date(dateString));
};

export default function Regulations() {
  const [showMore, setShowMore] = useState(false);

  const { data: currentTerms } = useQuery({
    queryKey: ["current-terms-list"],
    queryFn: () =>
      getTermsList({
        payload: {
          limit: 100,
          offset: 0,
          status: ["current"],
        },
      }),
    staleTime: TERMS_STALE_TIME,
    cacheTime: TERMS_CACHE_TIME,
  });

  const { data: archiveTerms } = useQuery({
    queryKey: ["archive-terms-list"],
    queryFn: () =>
      getTermsList({
        payload: {
          limit: 100,
          offset: 0,
          status: ["archive"],
        },
      }),
    staleTime: TERMS_STALE_TIME,
    cacheTime: TERMS_CACHE_TIME,
  });

  return (
    <section className="regulations-page">
      <PagesHeader>
        <strong>Allgemeine Bestimmungen</strong>
      </PagesHeader>
      <div className="regulations-wrapper">
        <div className="bg-contener"></div>
        <div className="regulations-content">
          <div className="regulations-inner">
            {currentTerms?.terms.map((term) => (
              <div className="term-item" key={term.ident}>
                <div>
                  <p
                    className="name"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(term.content?.title)}}
                  />
                  <p className="term-date">
                    <span>Veröffentlicht: </span>
                    {dateFormatter(term.validFrom)}
                  </p>
                </div>
                {term.file && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={term.file?.url}
                  >
                    <PdfIcon />
                  </a>
                )}
                {!term.file && (
                  <a href={`/terms/${term.uuid}`}>
                    <ArrowIcon />
                  </a>
                )}
              </div>
            ))}
          </div>
          <div className="terms-btn-wrapper">
            <ShowMoreButton
              copyMore="Archiviertes anzeigen"
              copyLess="Archiviertes ausblenden"
              showMore={showMore}
              setShowMore={setShowMore}
            />
          </div>
          <div
            className={`regulations-inner archived ${
              showMore ? "show" : "hide"
            }`}
          >
            {archiveTerms?.terms.map((term) => (
              <div className="term-item" key={term.ident}>
                <div>
                  <p
                    className="name"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(term.content?.title)}}
                  />
                  <p className="term-date">
                    <span>Veröffentlicht: </span>
                    {dateFormatter(term.validFrom)}
                  </p>
                </div>
                {term.file && (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={term.file?.url}
                  >
                    <PdfIcon />
                  </a>
                )}
                {!term.file && (
                  <a href={`/terms/${term.uuid}`}>
                    <ArrowIcon />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
